<template>
  <div>
    <Alert v-bind="alertprops"/>
    <v-data-table
      :headers="headers"
      :items="messageData"
      sort-by="name"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>Customer Message</v-toolbar-title>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          medium
          color="red"
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import Alert from '../../components/Alert'
  import ContactUsService from '../../services/ContactUsService'

  export default {
    name: "Company",
    components: {
      Alert
    },
    data: () => ({
      dialogDelete: false,
      headers: [
        {
          text: 'Customer Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        { text: 'Email', value: 'email', sortable: false, },
        { text: 'Subject', value: 'subject', sortable: false, },
        { text: 'Message', value: 'message', sortable: false, },
        { text: 'Send date (MM/DD/YY)', value: 'createdAt', sortable: true, },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      messageData: [],
      editedIndex: -1,
      alertprops: {
        alertType: '',
        content: '',
        alert: false
      }
    }),


    watch: {
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    updated() {
      setTimeout(()=>{
        this.alertprops.alert = false
      },2000)
    },

    methods: {
      ...mapActions(['logout']),
      
      initialize () {
        ContactUsService.read()
        .then(message => {
          this.messageData = message.data
        })
        .catch(err => {
          this.getAlertData("error", err.response.data.message, true)
          this.checkAuth(err)
        })
      },

      deleteItem (item) {
        this.editedIndex = this.messageData.indexOf(item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        ContactUsService.delete(this.messageData[this.editedIndex]._id)
        .then(res => {
          this.getAlertData("success", res.data.message, true)
          this.initialize()
          this.closeDelete()
        })
        .catch(err => {
          this.getAlertData("error", err.response.data.message, true)
        })
      },


      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedIndex = -1
        })
      },

      getAlertData(type, content, alert) {
        this.alertprops.alertType = type,
        this.alertprops.content = content,
        this.alertprops.alert = alert
      },

      checkAuth(err){
        if(err.response.status == 403){
          setTimeout(()=>{
            this.logout()
          },2000)
        }
      }

    },
  }
</script>